import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export enum SaveChangesDialogResult {
  SaveAndContinue = 0,
  ContinueWithoutSaving = 1,
  Cancel = 2,
}

@Component({
  selector: 'app-save-changes-dialog',
  templateUrl: './save-changes-dialog.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class SaveChangesDialogComponent {
  readonly text?: string;

  constructor(
    private dialogRef: MatDialogRef<SaveChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.text = data.text;
  }

  saveAndContinue(): void {
    this.dialogRef.close(SaveChangesDialogResult.SaveAndContinue);
  }

  continueWithoutSaving(): void {
    this.dialogRef.close(SaveChangesDialogResult.ContinueWithoutSaving);
  }

  cancel(): void {
    this.dialogRef.close(SaveChangesDialogResult.Cancel);
  }
}
